import { AUTH_RESET_PASSWORD_ACCEPT, AUTH_RESET_PASSWORD_ACCEPT_FAILED, AUTH_RESET_PASSWORD_ACCEPT_SUCCESS } from './types';
import { apiAction } from '../../api/actions';
import { AUTH_LOGIN_SUCCESS } from '../login/types';

export function resetPasswordAccept(token, email, password, onSuccess, onFailure) {
  return apiAction({
    resource: '/auth/reset-password-accept',
    method: 'POST',
    data: {
      token,
      email,
      password
    },
    onSuccess: (data) => onSuccessResetPasswordAccept(data, onSuccess),
    onFailure: (error) => onFailedResetPasswordAccept(error, onFailure),
    carry: {
      label: AUTH_RESET_PASSWORD_ACCEPT
    },
  });
}

function onSuccessResetPasswordAccept(data, onSuccess) {
  // If the backend returns user and token (auto-login), dispatch login success
  if (data.user && data.token) {
    // Save session data
    localStorage.setItem('token', data.token);
    localStorage.setItem('refreshToken', data.refreshToken);
    localStorage.setItem('tenant', data.tenant);

    // Call onSuccess with has2FA flag
    onSuccess(data.has2FA);

    // Return login success action to update Redux state
    return {
      type: AUTH_LOGIN_SUCCESS,
      payload: {
        user: data.user,
        token: data.token,
        tenant: data.tenant
      }
    };
  }

  // Fallback for old behavior
  onSuccess(false);
  return {
    type: AUTH_RESET_PASSWORD_ACCEPT_SUCCESS,
    payload: data
  };
}

function onFailedResetPasswordAccept(error, onFailure) {
  // Pass translation key to onFailure, component will translate it
  let translationKey = 'reset-password-accept.error-default';
  
  if (error?.response?.data?.error === 'EXPIRED_TOKEN') {
    translationKey = 'reset-password-accept.error-expired';
  } else if (error?.response?.data?.error === 'TOKEN_ALREADY_USED') {
    translationKey = 'reset-password-accept.error-already-used';
  } else if (error?.response?.data?.error === 'INVALID_TOKEN') {
    translationKey = 'reset-password-accept.error-invalid';
  } else if (error?.response?.data?.message) {
    // If backend provides a message, use it directly
    translationKey = error.response.data.message;
  }
  
  onFailure(translationKey);
  return {
    type: AUTH_RESET_PASSWORD_ACCEPT_FAILED,
    payload: {
      error
    }
  };
}
